import { useEffect } from "react";

/**
 * Auto-plays or pauses a video element when it scrolls into/out of view.
 *
 * @param {React.RefObject<HTMLVideoElement>} videoRef
 * @param {IntersectionObserverInit} options
 */
export function usePlayWhenVisible(
  videoRef,
  options = { root: null, rootMargin: "0px", threshold: 0.5 }
) {
  useEffect(() => {
    const el = videoRef.current;
    if (!(el instanceof HTMLVideoElement)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.play().catch(() => {}); // swallow play() promise errors
        } else {
          el.pause();
        }
      });
    }, options);

    observer.observe(el);

    return () => {
      observer.unobserve(el);
      observer.disconnect();
    };
  }, [videoRef, JSON.stringify(options)]);
}